import type Model from '@ember-data/model';

/**
 * @param record record
 * @param relationship relationship to load
 * @param type relationship type
 *
 * @returns the resolved relationship
 */
export async function loadAsyncRelationship<M extends Model, K extends Exclude<keyof M, keyof Model>>(
  record: M,
  relationship: K,
  type: 'belongsTo' | 'hasMany' = 'belongsTo',
): Promise<Awaited<M[K]> | undefined> {
  const hasRel =
    type === 'hasMany' ? record.hasMany(relationship).ids()?.length > 0 : Boolean(record.belongsTo(relationship).id());

  if (hasRel) {
    let resolved: Awaited<M[K]> | undefined;
    try {
      // eslint-disable-next-line @typescript-eslint/await-thenable
      resolved = await record[relationship];
    } catch (_error) {
      // no op
    }

    return resolved;
  }

  return;
}
